import { useTheme } from '@mui/material/styles'
import { Box, Drawer, useMediaQuery, Grid } from '@mui/material'
import { MobileView, BrowserView } from 'react-device-detect'
import MenuList from './MenuList'
import { drawerWidth } from 'src/store/constant'
import useAuth from 'src/hooks/useAuth'
import { adminTokens } from 'src/views/common/adminTokens'
import PhosphorIcon from 'src/views/common/PhosphorIcon'

export interface SidebarProps {
    drawerOpen?: boolean
    drawerToggle?: () => void
    window?: Window
}

const footerRowSx = (drawerOpen?: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    height: 40,
    width: '100%',
    padding: drawerOpen ? '0 12px' : 0,
    justifyContent: drawerOpen ? 'flex-start' : 'center',
    borderRadius: adminTokens.radiusMd,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontFamily: adminTokens.fontSans,
    fontSize: adminTokens.textBase,
    fontWeight: 500,
    color: adminTokens.gray600,
    '&:hover': { background: adminTokens.gray100, color: adminTokens.navy800 },
})

const Sidebar = ({ drawerOpen, drawerToggle, window }: SidebarProps) => {
    const theme = useTheme()
    const { logout } = useAuth()
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'))

    const handleLogout = async () => {
        try {
            await logout()
        } catch (err) {
            console.error(err)
        }
    }

    const drawer = (
        <>
            <BrowserView style={{ height: '100%' }}>
                <Grid container direction={'row'} style={{ height: '100%' }}>
                    <Grid item xs={12} sx={{ position: 'relative', bgcolor: adminTokens.surface, minHeight: 0, overflowY: 'auto' }}>
                        <Box sx={{ padding: 1.5 }}>
                            <MenuList />
                        </Box>
                    </Grid>
                    <Grid item container alignSelf='flex-end' xs sx={{ position: 'sticky', bottom: 0, left: 0, bgcolor: adminTokens.surface }}>
                        <Grid item xs={12} sx={{ borderTop: adminTokens.borderMd, mx: 1.5, mb: 1, pt: 1 }}>
                            <Box component="button" type="button" onClick={handleLogout} sx={footerRowSx(drawerOpen)}>
                                <PhosphorIcon name="sign-out" size={16} color="currentColor" />
                                {drawerOpen ? 'Logout' : ''}
                            </Box>
                        </Grid>
                        <Grid item xs={12} sx={{ px: 1.5, pb: 1.5 }}>
                            <Box component="button" type="button" onClick={drawerToggle} sx={footerRowSx(drawerOpen)}>
                                <PhosphorIcon name={drawerOpen ? 'caret-double-left' : 'caret-double-right'} size={16} color="currentColor" />
                                {drawerOpen ? 'Collapse sidebar' : ''}
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </BrowserView>
            <MobileView>
                <Box sx={{ px: 2 }}>
                    <MenuList />
                </Box>
            </MobileView>
        </>
    )

    const container = window !== undefined ? () => window.document.body : undefined

    return (
        <Box component='nav' sx={{ height: '100%' }}>
            <Drawer
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor='left'
                open={true}
                sx={{
                    height: '100%',
                    '& .MuiDrawer-paper': {
                        width: drawerOpen ? drawerWidth : 65,
                        transition: 'width 0.2s ease-in-out',
                        height: '100%',
                        position: 'unset',
                        borderRight: 'none',
                    }
                }}
                ModalProps={{ keepMounted: true }}
            >
                {drawer}
            </Drawer>
        </Box>
    )
}

export default Sidebar
